import * as React from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import { HeaderContent, TableSizeType } from '../../types/reports';
import ReportHeader from './ReportHeader';
import { getTableBorderColor } from '../../utils/table';

interface Props {
  type?: TableSizeType;
  headerContent?: HeaderContent;
  isLoading?: boolean;
  contentBoxStyle?: React.CSSProperties;
  children: React.ReactNode;
}

export default function ReportBox({
  headerContent,
  isLoading = false,
  contentBoxStyle = {},
  children,
  type = 'compact',
}: Props) {
  const theme = useTheme();

  return (
    <Paper
      elevation={type === 'compact' ? 3 : 0}
      sx={{
        width: '100%',
        border: `1px solid ${getTableBorderColor(theme, type)}`,
        borderRadius: type === 'compact' ? '4px' : '10px',
      }}>
      <ReportHeader
        headerContent={headerContent}
        isLoading={isLoading}
        type={type}
      />
      <Box
        sx={{
          width: '100%',
          justifyContent: 'start',
          ...contentBoxStyle,
        }}>
        {children}
      </Box>
    </Paper>
  );
}
